<template>
  <div>
    <b-row class="mt-4">
      <b-col md="12">
        <b-list-group>
          <b-list-group-item
            ref="lista"
            v-for="item in listaSolicitudes.rows"
            :key="item.Id"
            style="cursor:pointer;">
            <b-card border-variant="primary" :bg-variant="light" :title="item.PersonalString.toUpperCase()">
              <lista-solicitud-alta-medica-item :item="item"></lista-solicitud-alta-medica-item >
            </b-card>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <paginacion-solicitud-alta-medica></paginacion-solicitud-alta-medica>
  </div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import Solicitudsvc from "@/services/solicitudes";
import LicenciaCargoPersonalSvc from "@/services/licenciacargopersonal";
import TablaBase from "../common/TablaBase.vue";
import ListaSolicitudAltaMedicaItem from "../common/ListaSolicitudAltaMedicaItem.vue";
import PaginacionSolicitudAltaMedica from "../common/PaginacionSolicitudAltaMedica.vue";
import DetalleSolicitudAltaMedica from "../common/DetalleSolicitudAltaMedica.vue";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'SolicitudAltaModule/getSolicitudAltaField'
});
// const { mapFields: mapFormLicenciaFields } = createHelpers({
//   getterType: 'FormLicenciaModule/getLicenciaField',
//   mutationType: 'FormLicenciaModule/updateLicenciaField',
// });
// const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
//   getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
//   mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
// });
export default {
  name: "ListaSolicitudAltaMedica",
  mixins: [errorhandler, swalerts],
  props: {
  },
  watch: {
  },
  components: {
    TablaBase,
    ListaSolicitudAltaMedicaItem,
    PaginacionSolicitudAltaMedica,
    DetalleSolicitudAltaMedica
  },
  computed: {
    // ...mapFormBuscarPersonalFields(['Personal_Id', 'ListaLicencias']),
    // ...mapFormLicenciaFields([
    //   "SolicitudSeleccionada",
    //   "SolicitudSeleccionada_Id"]),
    ...mapGetters([
      "isAuthenticated",
      "getUserName",
      "getUserInfo",
      "isInRoleAdmin",
      "isInRoleCoordinador",
      "isInRoleEstablecimiento",
      "getEstablecimiento"
    ]),
    ...mapFields({
      articulosEscuela: 'articulosEscuela',
      filtroEstado: 'filtro.estado',
      filtroDestino: 'filtro.destino',
      listaSolicitudes: 'tabla',
      solicitudSeleccionada: 'selected'
    }),
    paginacionActual: function(){
      return this.listaSolicitudes.perPage * this.listaSolicitudes.currentPage;
    },
    paginacionDesde: function() {
      return (this.paginacionActual - this.listaSolicitudes.perPage);
    },
    paginacionHasta: function(){
      var paginahasta = this.paginacionDesde + this.listaSolicitudes.perPage;
      if((this.listaSolicitudes.totalRows - paginahasta) < 0 ){
        return this.listaSolicitudes.totalRows;
      }
      return paginahasta;
    },
    paginacionString: function(){
      return `Mostrando ${this.paginacionDesde} a ${this.paginacionHasta} de ${this.listaSolicitudes.totalRows} items.`;
    }
  },
  data() {
    return {
      disabled: false
    };
  },
  methods: {
    ...mapActions("SolicitudAltaModule",
    ["solicitudProvider",
    "getSolicitudAlta", "setSelected","cambiarEstado","eliminar", "setCurrentPage"]),
    show(item) {
      this.verDetalles(item);
    },
    hide() {
      this.solicitudSeleccionada.id = -1;
    },
    verDetalles(item) {
      console.log('ver detalles', item);
      this.getSolicitudAlta(item.Id);
    },
    solicitudProviderLocal(resetPagination) {
      this.disabled = true;
      console.log('resetPagination', resetPagination);
      this.solicitudProvider(resetPagination).then(r => {
        console.log('solicitudprovider then', r);

        this.disabled = false;
      });
    },
    enviarSolicitud(item, establecimiento) {
      console.log('enviarSolicitud', item, establecimiento);
      console.log('enviarSolicitud', this.listaSolicitudes.rows.length);
      var ajustarPaginacion = this.listaSolicitudes.rows.length === 1;
      this.showConfirmarInfo('Confirmar',`La solicitud ${item.Id}|${item.ToString} será enviada a ${establecimiento.DisplayNivelAsignado}.`, 'Enviar')
      .then((willChange) => {
        console.log('then willChange', willChange);
        if (willChange.isConfirmed) {
          this.cambiarEstado({
              id: item.Id,
              estado: { value: 4, text: 'Enviado'},
              nivelenseñanza_id: establecimiento.NivelEnseñanza_Id,
              unidadeducativa_id: establecimiento.UnidadEducativa_Id,
              unidadadministrativa_id: establecimiento.UnidadAdministrativa_Id,
            })
            .then(response => {
              console.log('cambiarEstado then', response);
              this.verDetalles(response.data.objeto.Editado);
              if(ajustarPaginacion){
                this.solicitudProviderLocal(1);
              }else{
                this.solicitudProviderLocal(this.listaSolicitudes.currentPage);
              }
              this.showSuccess(response.data.status.mensaje);
            })
            .catch(error => {
              this.errorHandler(e);
            });
        }
      });
    },
    rechazarSolicitud(item) {
      this.$router.push({ name: 'rechazarsolicitudpersonal', params: { solicitud: item } });
    },
    noAutorizarSolicitud(item) {
      this.$router.push({ name: 'noAutorizarSolicitudpersonal', params: { solicitud: item } });
    },
    recibirSolicitud(item) {
      this.$router.push({ name: 'recibirsolicitudpersonal', params: { solicitud: item } });
    },
    altaMedicaSolicitud(item) {
      this.$router.push({ name: 'altamedicasolicitudpersonal', params: { solicitud: item } });
    },
    eliminarSolicitud(item) {
      console.log('eliminarSolicitud', item);
      console.log('eliminarSolicitud', this.listaSolicitudes.rows.length);
      var ajustarPaginacion = this.listaSolicitudes.rows.length === 1;
      this.showConfirmarDanger(`La solicitud ${item.Id}|${item.ToString} sera eliminada.`, 'Eliminar')
      .then((willDelete) => {
        console.log('then willDelete', willDelete);
        if (willDelete.isConfirmed) {
          this.eliminar(item).then(r => {
            console.log('eliminar then', r);
            if(ajustarPaginacion){
              this.solicitudProviderLocal(1);
            }else{
              this.solicitudProviderLocal(this.listaSolicitudes.currentPage);
            }
            this.showSuccess(r.data.status.mensaje);
          })
          .catch(e => {
            this.errorHandler(e);
          });
        }
      });
    },

    registrarLicencia(item) {
      Solicitudsvc.get({
        id: item.Id,
        incluyecargopersonal: true,
        incluyelicenciacargopersonal: true,
        incluyehistorialsolicitudmedica: true,
      }).then(e => {
        console.log("Solicitudsvc.get then: ", e.data);
        this.SolicitudSeleccionada = e.data.objeto;
        LicenciaCargoPersonalSvc.getLista({
          desde: ((new Date().getFullYear()) - 1) + '-01-01',
          limit: 500,
          incluyecargopersonal: true,
          personal_id: this.SolicitudSeleccionada.Personal_Id,
        }).then(l => {
          this.ListaLicencias = l.data.rows;
          console.log('registrarLicencia', item);
          this.$router.push({ name: 'registrarlicenciasolicitud', params: { solicitud_id: item.Id, dni: item.DisplayDni } });
        }).catch(err => {
          console.log("Error licenciasProvider", err);
          this.errorHandler(e);
        });;
      }).catch(error => {
        console.log("Error en Solicitudsvc.get", error.response.data);
        this.errorHandler(error);
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/ListaSolicitudAltaMedica.vue